/**
 * MIT License
 *
 * Copyright (c) 2023 Jamasp Team <mailto:radmanesh@gmail.com Arman Radmanesh> <mailto:salarirad@gmail.com Salar Rad>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Alert, Backdrop, Box, CircularProgress, Container, LinearProgress } from '@mui/material';
import { Fragment, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../auth/AuthContext';
import Footer from '../components/layout/Footer';
import Navbar from '../components/layout/Navbar';
import { useAlert } from '../context/AlertContext';
import PropTypes from 'prop-types';

const ProtectedLayout = ({ role, children }) => {
  const { currentUser, loading, phoneVerified, userJamasp, userClaims } = useAuthContext();
  const { alerts, addAlert } = useAlert();
  const navigate = useNavigate();

  //console.log("ProtectedLayout : %o %o %o %o : %s", currentUser, loading, phoneVerified, userJamasp, role);

  useEffect(() => {
    // Fetch user data again if it's still null
    if (!loading && !currentUser) {
      console.log("it's not loading and currentUser is null", loading, currentUser);
      navigate('/auth/login')
    }
    if (userJamasp)
      console.log("userJamasp: %o , currenUser: %o", userJamasp, currentUser);

    if (!loading && role === 'admin' && userClaims?.admin !== true) {
      console.log("ProtectedLayout is redirecting to adminDashboard", currentUser, userJamasp, loading, phoneVerified);
      console.log("ProtectedLayout role: %o, claims: %s", role, currentUser?.customClaims);
      addAlert("error", "You are not authorized to access this page");
      navigate('/');
    }

    // This really good for fitbit auth lets use it there
    // if (!loading && userJamasp && !phoneVerified) {
    //   navigate('/auth/phone-verify')
    // }
    // if (!loading && userJamasp && phoneVerified) {
    //   console.log("ProtectedRoute is redirecting to dashboard", currentUser, loading, phoneVerified);
    //   //navigate('/home');
    // }
  }, [userJamasp, userClaims, loading, phoneVerified, currentUser, role, navigate, addAlert]);



  //return userJamasp ? null : children ? children : (
  return children ? children : (
    <Container maxWidth="xl">
      <Box minHeight="100vh" display="flex" flexDirection="column" >
        <Navbar role={role} />
          {loading && (
            // Show a loading indicator while the user checks if they are logged in
            <Fragment>
              <Backdrop
                sx={{ color: '#fff' }}
                open={loading}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <LinearProgress />
            </Fragment>
          )}
          {alerts.map((alert, index) => (
            <Alert key={index} severity={alert.type}>
              {alert.message}
            </Alert>
          ))}
          <Outlet />

        <Footer />
      </Box>
    </Container>
  );

}

ProtectedLayout.propTypes = {
  role: PropTypes.string,
  children: PropTypes.node
};

export default ProtectedLayout